<template>
    <div class="pp-divider">
        <span class="pp-divider__inner">
            <slot>{{text}}</slot>
        </span>
    </div>
</template>

<script>
export default {
    name: 'pp-divider',
    props: {
        text: String
    }
}
</script>
